import React from "react";
import { TooltipProps } from "@material-ui/core";

import { TooltipStyled } from "./GraphTooltip.style";

export function GraphTooltip({ children, ...props }: TooltipProps) {
    return <TooltipStyled {...props}>{children}</TooltipStyled>;
}
